import Vue from "vue";
import { Config } from "@/shared/config";

const financialServiceUri = Config.FinancialServicebaseUri;

export default {
  get financialV1 () {
    return `${financialServiceUri}/finicity/v1`;
  },
  getLinkFinancialCardUrl () {
    return `${this.financialV1}/account/generateurl`;
  },
  getLinkCardMaintenanceUrl () {
    return `${this.financialV1}/account/generateMaintenanceUrl`;
  },
  getLinkedCardNeedsMaintenance () {
    return `${this.financialV1}/account/needsMaintenance`;
  },
  refreshCustomerAccount () {
    return `${this.financialV1}/account/refresh`;
  },
  deleteCustomerAccount (userAccountId: number) {
    return `${this.financialV1}/account/${userAccountId}`;
  },
  deleteCustomerAccountsByLogin (loginId: number) {
    return `${this.financialV1}/account/accounts/${loginId}`;
  }
};